module.exports = __webpack_public_path__ + "media/images/xc_5-58eca1c809eeb63c69edeb8a55378cb5.png";